import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Inject, Injectable, Optional } from '@angular/core';
import { of } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { environment } from '../../environments/environment';
import { SP_ERROR_HANDLERS } from '../common/http-error-handlers';
import { ApiConnectionService } from '../common/utils/apiConnectionService';
import { requestWithFallback } from '../common/utils/requestWithFallback';
import { ApiResponse } from '../shared/models/common.models';
import { SPErrorHandler } from '../shared/models/misc.models';
import { IPaymentStatus } from '../shared/models/widget.model';

@Injectable()
export class ApiPayService {
  private apiPayBaseUrl: string = environment.paymentBaseUrl;

  constructor(
    private http: HttpClient,
    private apiConnection: ApiConnectionService,
    @Optional()
    @Inject(SP_ERROR_HANDLERS)
    private additionalErrorHandlers: SPErrorHandler[],
  ) {}

  public readonly payment = ((api: this) => ({
    getPaymentStatus(orderUid: string) {
      return api.get<IPaymentStatus>('get-pay-status', { orderUid }, false);
    },
  }))(this);

  private get<T>(
    url: string,
    params: { [key: string]: any },
    useDefaultErrorHandling = true,
  ) {
    const request = requestWithFallback(
      url,
      (fullUrl) => this.http.get<ApiResponse<T>>(fullUrl, { params }),
      this.apiConnection.paymentBaseUrlFallbackView,
    );

    if (useDefaultErrorHandling) {
      return request.pipe(
        catchError((error: HttpErrorResponse) => {
          return this.handleErrors(error);
        }),
      );
    } else {
      return request.pipe(
        catchError((error: HttpErrorResponse) => {
          return this.mapHttpErrorToApiResponse(error);
        }),
      );
    }
  }

  private handleErrors = ((api: this) => (error: HttpErrorResponse) => {
    if (api.additionalErrorHandlers) {
      api.additionalErrorHandlers.forEach((handler) => handler.handle(error));
    }
    return this.mapHttpErrorToApiResponse(error);
  })(this);

  private mapHttpErrorToApiResponse<T>(error: HttpErrorResponse) {
    const res: ApiResponse<any> = {
      confirmEmail: false,
      confirmPhone: false,
      desc:
        (error.error && error.error.desc) ||
        (error.status === 0
          ? 'Произошла сетевая ошибка. Проверьте, что подключение к интернету работает стабильно.'
          : error.message),
      result: null,
      error,
    };
    return of(res);
  }
}
